import { SOCKET_PING_INTERVAL } from '@/utils/constants'
import { useEffect } from 'react'
import { useState } from 'react'
// import { socketURL } from '../api/request'
// import NetInfo from '@react-native-community/netinfo'
import { useRef } from 'react'
import useNotificationStorageHook from './useNotificationStorageHook'
import { SocketMessage } from '@/types/notification'
// import { updateOnlineStatus } from '../stores/user.reducer'
// import { showToast } from '../components/CustomToast'
// import { handleSocketMessage } from '../utils/SocketNotifier'
// import { SOCKET_PING_INTERVAL } from '../../constant'

const messagesToSkip = [
  'Hi--No events to send',
  'Hi--Events queued',
  'Hi--invalid input data',
  'Internal server error',
]

const RECONNECT_INTERVAL = 15 * 1000 // 10 seconds

const socketURL = 'wss://1gt20kn9ma.execute-api.us-east-1.amazonaws.com/testing'
const useWebSocketHook = () => {
  const [isConnected, setIsConnected] = useState(false)
  const [socket, setSocket] = useState<WebSocket | null>(null)

  const socketAlive = useRef(false) // To check if server is responding to ping
  const pingInterval = useRef<NodeJS.Timer | null>(null)
  const reconnectInterval = useRef<NodeJS.Timer | null>(null)
  const ws = useRef<WebSocket | null>(null)
  const [userNameGlobal, setUserNameGlobal] = useState('')
  const userNameRef = useRef('') // always holds the latest username for interval callbacks

  const { addMessage } = useNotificationStorageHook()

  const stopPing = () => {
    if (pingInterval.current) clearInterval(pingInterval.current)
  }

  const stopReconnect = () => {
    if (reconnectInterval.current) clearInterval(reconnectInterval.current)
    reconnectInterval.current = null
  }

  // Forces a fresh reconnect every RECONNECT_INTERVAL, regardless of
  // whether the socket currently looks connected — this is a workaround
  // since ping/keepalive isn't reliably detecting dead connections.
  const startReconnect = (userName: string) => {
    userNameRef.current = userName

    // Avoid stacking multiple reconnect intervals
    if (reconnectInterval.current) return

    reconnectInterval.current = setInterval(() => {
      console.log('~~~~~~~~~~ [FORCED RECONNECT] ~~~~~~~~~~')

      // Tear down existing socket (if any) before reconnecting
      if (ws.current) {
        ws.current.close(1000, 'Forced periodic reconnect')
        ws.current = null
      }
      setSocket(null)
      setIsConnected(false)

      connectWebSocket(userNameRef.current)
    }, RECONNECT_INTERVAL)
  }

  useEffect(() => {
    // Monitor network connectivity changes

    const unsubscribe = () => {}
    /*
    const unsubscribe = NetInfo.addEventListener((state) => {
      if (state.isConnected && !isConnected) {
        // Reconnect WebSocket if network connection is restored
        connectWebSocket(userNameGlobal)
      }
    })
     */

    return () => {
      if (socket) {
        console.log('~~~~~~~~~~ [DISCONNECT REQUEST] ~~~~~~~~~~')
        stopPing()
        stopReconnect()
        if (socket && ws.current) {
          socket.close(1000, 'Connection closed forcefully')
          ws.current.close(1000, 'Connection closed forcefully')
        }
      }
      unsubscribe()
    }
  }, [])

  useEffect(() => {
    if (userNameGlobal?.length > 0) {
      userNameRef.current = userNameGlobal
      connectWebSocket(userNameGlobal)
      startReconnect(userNameGlobal)
    } else {
    }
  }, [userNameGlobal])

  const connectWebSocket = (userName: string) => {
    if (ws?.current != null && ws?.current?.readyState == WebSocket.OPEN) {
      return
    } else if (userName?.length > 0) {
      console.log('~~~~~~~~~~ [CONNECTING] ~~~~~~~~~~')
      ws.current = new WebSocket(socketURL)

      // Events
      ws.current.onopen = () => {
        console.log('~~~~~~~~~~ [CONNECTED] ~~~~~~~~~~')
        setUserNameGlobal(userName)
        setSocket(ws.current)
        setIsConnected(true)
        socketAlive.current = true

        // NOTE: reconnect interval intentionally keeps running even after
        // a successful connect, as a workaround for ping not working.

        try {
          console.log('Username: ', userName)
          if (userName?.length > 0) {
            const socketData = {
              action: 'sendMessage',
              userName,
            }
            const json = JSON.stringify(socketData)
            ws.current?.send(json)

            sendPing()
            stopPing()

            pingInterval.current = setInterval(sendPing, SOCKET_PING_INTERVAL)
          }
        } catch (err) {
          console.log('Error Sending: ', err)
        }
      }

      ws.current.onmessage = (event) => {
        const { data: socketMessage } = event
        console.log('~~~~~~~~~~ [MESSAGE RECEIVED] ~~~~~~~~~~')
        console.log('WebSocket message received:', socketMessage)
        socketAlive.current = true

        if (!messagesToSkip.includes(socketMessage)) {
          const parsedMessage = JSON.parse(socketMessage)
          // Ignoring own events.
          if (userNameGlobal != parsedMessage?.eventData?.sourceUserName) {
            addMessage(parsedMessage)
          } else {
            console.log('SENT TO SELF')
          }
        }
      }

      ws.current.onerror = (error) => {
        console.log('~~~~~~~~~~ [WEBSOCKET ERROR] ~~~~~~~~~~')
        console.error('WebSocket error:', error)
      }

      ws.current.onclose = (event) => {
        console.log('Close Event: ', event)
        console.log('~~~~~~~~~~ [WEBSOCKET CLOSED] ~~~~~~~~~~')
        // showToast('error', 'SOCKET DISCONNECTED');
        setSocket(null)
        ws.current = null
        setIsConnected(false)

        // The periodic reconnect interval (started in the userNameGlobal
        // effect) will pick this back up on its next tick, so we don't
        // need to do anything extra here for reconnects on unclean close.
      }
    }
  }

  const sendPing = () => {
    if (ws?.current != null) {
      if (ws.current.readyState == WebSocket.OPEN) {
        if (socketAlive.current == false) {
          connectWebSocket('')
        }

        const pingMessage = JSON.stringify({ type: 'ping' })
        ws?.current?.send(pingMessage)
      } else {
        console.log('WebSocket connection is not open')
      }
    }
  }

  const disconnect = () => {
    console.log('~~~~~~~~~~ [DISCONNECT REQUEST] ~~~~~~~~~~')
    //clearInterval(pingInterval.current)
    stopPing()
    stopReconnect()
    socket?.close(1000, 'Connection closed from logout')
    ws.current?.close(1000, 'Connection closed from logout')
  }

  return { socket, connectWebSocket, disconnect }
}

export default useWebSocketHook
